import student from './student.js';
import validation from './validation.js';
import employee from './employee.js';
// import professor from './professor.js';
// import staff from './staff.js';
import program from './program.js';
import company from './company.js';
import course from './course.js';
import book from './book.js';
// import bookbundle from './bookbundle.js';
import invoice from './invoice.js';
import importTool from './import.js';
import notification from './notification.js';
import setting from './setting.js';
import gradingScales from './gradingScales.js';
import paymentSummary from './paymentSummary.js';
// import role from './role.js';
// import user from './user.js';

const form = {
    student,
    validation,
    employee,
    // professor,
    // staff,
    program,
    company,
    course,
    book,
    // bookbundle,
    invoice,
    import: importTool,
    notification,
    setting,
    gradingScales,
    paymentSummary,
    // role,
    // user,
    audit: {
        field: 'Field',
        oldValue: 'Old Value',
        newValue: 'New Value',
        changeBy: 'Changed by',
        changeDate: 'Change Date'
    }
};

export default form;